'use strict';

var Event = require('./event');
var spiderList = ['baiduspider', 'googlebot', 'bingbot', 'yammybot', '360spider', 'haosouspider', 'youdaobot', 'sogou news spider', 'yisouspider', 'mtdp-infosec', 'mtdp-searchspider', 'yandexbot', 'yandexmobilebot'];
var _int64Convert = require('int64-convert');
var uuid = require('uuid');
var _uuid = uuid && uuid.__esModule ? uuid : { default: uuid };

module.exports = {
    // 复写History对象方法以实现路由变化的监听
    hackHistoryStateFuncs: function hackHistoryStateFuncs() {
        if (this.historyStateHacked) return;

        var ADD_EVENT = window.addEventListener || window.attachEvent;
        var that = this;
        ADD_EVENT('hashchange', function (event) {
            try {
                var newURL = event && event.newURL || '';
                var oldURL = event && event.oldURL || '';
                var curPath = that.parseRoutePath(newURL);
                var prePath = that.parseRoutePath(oldURL);
                if (curPath && prePath && curPath !== prePath) {
                    // 路由路径发生了变化
                    Event.trigger('validStateChange', { path: curPath });
                }
            } catch (e) {
                that.reportSysError(e);
            }
        });

        try {
            this.hackStateFunc('pushState');
            this.hackStateFunc('replaceState');
        } catch (e) {
            this.reportSysWarn(e);
        }

        this.historyStateHacked = true;
    },
    hackStateFunc: function hackStateFunc(name) {
        var oldFunc = window.history[name];
        if (typeof oldFunc == 'function') {
            var that = this;
            window.history[name] = function (state, title, url) {
                var preHref = location.href;
                var result = oldFunc.apply(window.history, [].slice.call(arguments));
                var curHref = location.href; // location.href 已完成变更
                if (!url || typeof url != 'string' || curHref === preHref) return result;

                try {
                    var prePath = that.parseRoutePath(preHref);
                    var curPath = that.parseRoutePath(curHref);
                    if (curPath && prePath && curPath !== prePath) {
                        // 路由路径发生了变化
                        Event.trigger('validStateChange', { path: curPath });
                    }
                } catch (e) {
                    that.reportSysError(e);
                }

                return result;
            };
        }
    },
    // 解析出url的路径部分
    parseRoutePath: function parseRoutePath(url) {
        if (url && typeof url == 'string') {
            var path = url.replace(/^(https?:)?(\/\/[^\/]*)?/, '');
            var query = path.match(/\?.*$/) && path.match(/\?.*$/)[0] || '';
            var hashAfterQuery = query.match(/\#.*$/) && query.match(/\#.*$/)[0] || '';
            return path.replace(/\?.*$/, '') + hashAfterQuery;
        } else {
            return '';
        }
    },
    getHref: function getHref() {
        return location && location.href || '';
    },
    getProtocol: function getProtocol() {
        return location && location.protocol || 'https:';
    },
    getOrigin: function getOrigin() {
        return location.origin || location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    },
    getPageUrl: function getPageUrl() {
        return this.getHref().replace(/\?.*(?=(\#))/, '').replace(/\?.*/, '');
    },
    getPerfTiming: function getPerfTiming() {
        return window.performance && window.performance.timing;
    },
    getConnectionType: function getConnectionType() {
        var connection = window.navigator && window.navigator.connection;
        return connection ? connection.effectiveType || connection.type || '' : '';
    },
    reportSysError: function reportSysError(err) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var errManager = window.Owl && window.Owl.errManager;
        if (errManager && typeof errManager.reportSystemError === 'function') {
            errManager.reportSystemError(err, opts);
        }
    },
    reportSysWarn: function reportSysWarn(err, opts) {
        opts = opts || {};
        opts.level = 'warn';
        this.reportSysError(err, opts);
    },
    getUserAgent: function getUserAgent() {
        return window.navigator && window.navigator.userAgent || '';
    },
    getAppName: function getAppName() {
        return window.navigator.appName;
    },
    checkIsSpider: function checkIsSpider() {
        try {
            var ua = this.getUserAgent().toLowerCase();
            for (var i = 0; i < spiderList.length; i++) {
                if (ua.indexOf(spiderList[i]) > -1) return true;
            }
        } catch (e) {
            this.reportSysError(e);
        }
        return false;
    },
    getFullUrl: function getFullUrl(url) {
        if (url.indexOf('//') === 0) {
            url = this.getProtocol() + url;
        } else if (url.indexOf('/') === 0) {
            url = this.getOrigin() + url;
        }
        return url;
    },
    checkSameOrigin: function checkSameOrigin(url) {
        var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        origin = origin || this.getOrigin();
        if (!(url && origin)) return false;

        url = this.getFullUrl(url);
        return url.indexOf(origin) === 0;
    },
    traceid: function traceid() {
        try {
            var uu = _uuid.default.v1().replace(/-/g, '');
            var f16 = uu.slice(0, 16);
            var l16 = uu.slice(16);
            var hex = Array(16).fill(0).map(function (_, i) {
                return parseInt(f16[15 - i], 16) ^ parseInt(l16[15 - i], 16);
            }).map(function (it) {
                return it.toString(16);
            }).join('');
            return (0, _int64Convert.signedHexToDec)(hex);
        } catch (e) {
            this.reportSysError(e);
            return '';
        }
    },
    getXPath: function getXPath(node) {
        var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

        try {
            var id = node.id ? '#' + node.id : '';
            var className = 'string' === typeof node.className && node.className ? '.' + node.className.split(' ').join('.') : '';
            var nodeName = 'string' === typeof node.nodeName ? node.nodeName.toLowerCase() : '';
            var path = nodeName + id + className;
            return node.parentNode && node.parentNode.nodeName && count - 1 > 0 ? this.getXPath(node.parentNode, count - 1) + ' > ' + path : path;
        } catch (e) {
            return '';
        }
    }
};